(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slidehome"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".custom-video-slider");
  if (!slider) return;

  const container = slider.querySelector(".slider-container");
  const slides = slider.querySelectorAll(".slide");
  const dotsContainer = slider.querySelector(".slider-dots");
  const prevBtn = slider.querySelector(".slider-arrow.prev");
  const nextBtn = slider.querySelector(".slider-arrow.next");

  let current = 0;
  const total = slides.length;
  let autoplayInterval;

  const createDots = () => {
    dotsContainer.innerHTML = "";
    for (let i = 0; i < total; i++) {
      const dot = document.createElement("span");
      dot.className = "dot";
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => { goToSlide(i); resetAutoplay(); });
      dotsContainer.appendChild(dot);
    }
  };

  const goToSlide = (index) => {
    current = (index + total) % total;
    container.style.transform = `translateX(-${current * 100}%)`;
    dotsContainer.querySelectorAll(".dot").forEach((d,i) => d.classList.toggle("active", i===current));

    slides.forEach((slide, i) => {
      const video = slide.querySelector("video");
      const iframe = slide.querySelector("iframe");
      if (i === current) {
        video && video.play();
        iframe && iframe.contentWindow.postMessage(
          iframe.src.includes('youtube') ? '{"event":"command","func":"playVideo","args":""}' : '{"event":"command","method":"play"}', '*');
      } else {
        video && video.pause();
        iframe && iframe.contentWindow.postMessage(
          iframe.src.includes('youtube') ? '{"event":"command","func":"pauseVideo","args":""}' : '{"event":"command","method":"pause"}', '*');
      }
    });
  };

  const resetAutoplay = () => {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => goToSlide(current + 1), (slider.dataset.transition || 6) * 1000);
  };

  nextBtn.addEventListener("click", () => { goToSlide(current + 1); resetAutoplay(); });
  prevBtn.addEventListener("click", () => { goToSlide(current - 1); resetAutoplay(); });
  createDots();
  goToSlide(0);
  resetAutoplay();

  slider.addEventListener("mouseenter", () => clearInterval(autoplayInterval));
  slider.addEventListener("mouseleave", resetAutoplay);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-form"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let selectedRating = 0;
    const stars = document.querySelectorAll('.star');
    const ratingInput = document.getElementById('rating');

    stars.forEach(star => {
      star.addEventListener('click', () => {
        selectedRating = star.getAttribute('data-value');
        ratingInput.value = selectedRating;
        stars.forEach(s => {
          s.classList.remove('selected');
          if (s.getAttribute('data-value') <= selectedRating) {
            s.classList.add('selected');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
/* (El código JS se mantiene igual al que tenías) */
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".custom-video-slider");
  if (!slider) return;
  const container = slider.querySelector(".slider-container");
  const slides = slider.querySelectorAll(".slide");
  const dotsContainer = slider.querySelector(".slider-dots");
  const prevBtn = slider.querySelector(".slider-arrow.prev");
  const nextBtn = slider.querySelector(".slider-arrow.next");
  let current = 0;
  const total = slides.length;
  let autoplayInterval;

  const goToSlide = (index) => {
    current = (index + total) % total;
    container.style.transform = `translateX(-${current * 100}%)`;
    dotsContainer.querySelectorAll(".dot").forEach((d,i) => d.classList.toggle("active", i===current));
  };

  const createDots = () => {
    dotsContainer.innerHTML = "";
    for (let i = 0; i < total; i++) {
      const dot = document.createElement("span");
      dot.className = "dot";
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => { goToSlide(i); });
      dotsContainer.appendChild(dot);
    }
  };

  nextBtn.addEventListener("click", () => goToSlide(current + 1));
  prevBtn.addEventListener("click", () => goToSlide(current - 1));
  createDots();
  goToSlide(0);
});

  } catch(e) { console.error(e); }
})();
})();
